/* istanbul ignore file */
import { SAVE_LEAD_ADDRESS } from '../constants/actionTypes'

const initialState = {
  address: null,
}

const initialLeadDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_LEAD_ADDRESS:
      return Object.assign({}, state, {
        address: action.address,
      })
    default:
      return state
  }
}

export default initialLeadDataReducer
export { initialState }
